import {getEnv} from './getEnv'

const strapiDomains = {
  local: process.env.IS_REMOTE_CMS ? 'http://delivery-frontend-cms.taxi.tst.yandex.net' : 'http://127.0.0.1:1337',
  unstable: 'http://delivery-frontend-cms.taxi.tst.yandex.net',
  testing: 'http://delivery-frontend-cms.taxi.tst.yandex.net',
  production: 'http://delivery-frontend-cms.taxi.yandex.net',
}

const experimentsDomains = {
  local: 'http://experiments3.taxi.tst.yandex.net',
  unstable: 'http://experiments3.taxi.tst.yandex.net',
  testing: 'http://experiments3.taxi.tst.yandex.net',
  production: 'http://experiments3.taxi.yandex.net',
}

export const strapiAPIHost = strapiDomains[getEnv()]

export const experimentsAPIDomain = experimentsDomains[getEnv()]
